"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManifestManagerApiSymbol = void 0;
exports.ManifestManagerApiSymbol = Symbol('ManifestManagerApi');
//# sourceMappingURL=manifest.js.map